import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "26",
  fill: "none",
  viewBox: "0 0 96 26"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FF0211",
  "fill-rule": "evenodd",
  d: "M22.497 7.551v11.077a1.87 1.87 0 0 1-1.055 1.672l-9.39 4.531a1.87 1.87 0 0 1-1.624 0L4.88 22.146l-3.824-1.872A1.85 1.85 0 0 1 0 18.602V7.525a1.85 1.85 0 0 1 1.055-1.657l9.384-4.689a1.87 1.87 0 0 1 1.666 0l9.368 4.71a1.86 1.86 0 0 1 1.024 1.662",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M95.879 9.112h-2.295v9.832h2.294zM68.972 17.05c-1.93 0-3.059-1.197-3.059-2.874s.87-3.017 2.901-3.017a6.9 6.9 0 0 1 3.023.722V9.735a7.9 7.9 0 0 0-3.065-.628c-3.123 0-5.111 2.152-5.111 5.069s2.168 4.847 5.274 4.847a8.4 8.4 0 0 0 3.123-.622v-2.11a7.9 7.9 0 0 1-3.086.76M39.033 9.112a3.69 3.69 0 0 0-3.091 1.525 3.9 3.9 0 0 0-3.165-1.525c-2.5 0-4.22 1.889-4.22 4.394v5.438h2.263v-5.67c0-1.203.728-2.11 1.962-2.11a1.985 1.985 0 0 1 2.031 2.11v5.67h2.22v-5.67a1.953 1.953 0 0 1 2-2.11 2 2 0 0 1 2.062 2.11v5.67h2.263v-5.438a4.22 4.22 0 0 0-4.325-4.394m55.696-1.076a1.271 1.271 0 1 0 0-2.542 1.271 1.271 0 0 0 0 2.542M78.842 9.113a4.81 4.81 0 0 0-4.996 4.947c0 2.912 1.968 4.948 4.78 4.948a3.08 3.08 0 0 0 2.853-1.667v1.582h2.257V14.06c.006-3.001-1.888-4.947-4.895-4.947m0 7.912c-1.662 0-2.696-1.134-2.696-2.965 0-1.688 1.16-2.959 2.695-2.959 1.636 0 2.638 1.16 2.638 2.96-.016 1.434-.913 2.964-2.659 2.964zM61.35 11.164c-1.24 0-1.967 1.029-1.967 2.395v5.385H57.12v-5.438c0-2.505 1.725-4.394 4.22-4.394h.817v2.052zm29.085 0c-1.24 0-1.967 1.029-1.967 2.395v5.385h-2.263v-5.438c0-2.505 1.725-4.394 4.22-4.394h.828v2.052zM50.353 9.107a4.83 4.83 0 0 0-4.874 4.974c0 3.091 2.215 4.927 5.274 4.927a10.9 10.9 0 0 0 3.577-.628v-1.983a10.6 10.6 0 0 1-3.471.744c-1.699 0-2.859-.755-3.102-2.284h6.858a8 8 0 0 0 .068-1.092 4.505 4.505 0 0 0-4.33-4.658m-2.575 3.977a2.511 2.511 0 0 1 4.953 0z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#4DC9FF",
  d: "M19.005 12.857a5.043 5.043 0 1 0 0-10.085 5.043 5.043 0 0 0 0 10.085"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m3.096 17.045-.986-.485v-2.917c0-.854.48-1.709 1.472-1.609a2.5 2.5 0 0 1 1.867 1.451 1.27 1.27 0 0 1 1.123-.316c.528.068 2.421.78 2.421 3.37v3.434l-1.08-.528v-3.228a1.714 1.714 0 0 0-1.357-1.814c-.321-.032-.6.227-.606.78-.005.554 0 3.276 0 3.276l-.992-.485V14.92c0-1.345-.87-1.762-1.25-1.804-.216 0-.612.11-.612.802z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }